import ptPlusApiBaseUrl from '../../../api/ptPlusApiBaseUrl';
import { showAppLoader, hideAppLoader } from '../app';

export const ptPlusUsersList = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  let fromDateVal = Math.trunc(data.startDate / 1000)
  let toDateVal = Math.trunc(data.endDate / 1000) + 86399
  return ptPlusApiBaseUrl.get(`/ptms/internal/user_list?fromDate=${fromDateVal}&endDate=${toDateVal}`, {
    headers: {
      Authorization: token,
      UserType: 'internal'
    },
  }).then((response) => {
    dispatch(hideAppLoader());
    return response.data;
  }).catch((ex) => {
    dispatch(hideAppLoader());
    if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
    else return ex;
  });
};

export const ptPlusParentUsersList = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return ptPlusApiBaseUrl.get(`/ptms/parent/customer_list`, {
    headers: {
      Authorization: token,
      UserType: 'internal'
    },
  }).then((response) => {
    dispatch(hideAppLoader());
    return response.data;
  }).catch((ex) => {
    dispatch(hideAppLoader());
    if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
    else return ex;
  });
};

export const updateRequestedOrder = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return ptPlusApiBaseUrl
    .post('/ptms/order/update/requested_order', data, {
      headers: {
        Authorization: token,
        UserType: 'internal'
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      // dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};
export const certificateListDetails = (token, id) => (dispatch) => {
  dispatch(showAppLoader());
  return ptPlusApiBaseUrl
    .get('/ptms/tax/certificate_list?id=' + id, {
      headers: {
        Authorization: token,
        UserType: 'internal'
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      // dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};
export const certificateListPTMS = (token, authId) => (dispatch) => {
  dispatch(showAppLoader());
  return ptPlusApiBaseUrl
    .get('/ptms/tax/get_ecomm_token?id=' + authId, {
      headers: {
        Authorization: token,
        UserType: 'internal'
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      // dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};

export const tableActonsApiFunc = (action, id, token) => (dispatch) => {
  dispatch(showAppLoader());
  return ptPlusApiBaseUrl.get(`ptms/internal/action/${id}/status/${action}`, {
    headers: {
      Authorization: token,
      UserType: 'internal'
    },
  }).then((response) => {
    dispatch(hideAppLoader());
    return response.data;
  }).catch((ex) => {
    dispatch(hideAppLoader());
    if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
    else return ex;
  });
};

export const userListDeleteFunc = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return ptPlusApiBaseUrl.post(`ptms/internal/delete_customer`, data, {
    headers: {
      Authorization: token,
      UserType: 'internal'
    },
  }).then((response) => {
    dispatch(hideAppLoader());
    return response.data;
  }).catch((ex) => {
    dispatch(hideAppLoader());
    if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
    else return ex;
  });
};

export const adminRegisterUserApi = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return ptPlusApiBaseUrl.post(`ptms/internal/customer_registration`, data, {
    headers: {
      Authorization: token,
      UserType: 'internal'
    },
  }).then((response) => {
    dispatch(hideAppLoader());
    return response.data;
  }).catch((ex) => {
    dispatch(hideAppLoader());
    if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
    else return ex;
  });
};

export const getDraftedRecordApi = (idVal, token) => (dispatch) => {
  dispatch(showAppLoader());
  return ptPlusApiBaseUrl.get(`ptms/internal/get_customer_registration_data/MAIN`, {
    headers: {
      Authorization: token,
      UserType: 'internal',
      id: idVal
    },
  }).then((response) => {
    dispatch(hideAppLoader());
    return response.data;
  }).catch((ex) => {
    dispatch(hideAppLoader());
    if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
    else return ex;
  });
};

export const adminUpdateUserApi = (url, data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return ptPlusApiBaseUrl.post(url, data, {
    headers: {
      Authorization: token,
      UserType: 'internal'
    },
  }).then((response) => {
    dispatch(hideAppLoader());
    return response.data;
  }).catch((ex) => {
    dispatch(hideAppLoader());
    if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
    else return ex;
  });
};

export const adminFlatFeeAddApi = (id, data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return ptPlusApiBaseUrl.post(`ptms/internal/add_flatfee/${id}`, data, {
    headers: {
      Authorization: token,
      UserType: 'internal'
    },
  }).then((response) => {
    dispatch(hideAppLoader());
    return response.data;
  }).catch((ex) => {
    dispatch(hideAppLoader());
    if (ex.response) return { error: true, data: ex.response?.data };
    return ex;
  });
};

export const adminFlatFeeUpdateApi = (id, data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return ptPlusApiBaseUrl.post(`ptms/user/update_flatfee/${id}`, data, {
    headers: {
      Authorization: token,
      UserType: 'internal'
    },
  }).then((response) => {
    dispatch(hideAppLoader());
    return response.data;
  }).catch((ex) => {
    dispatch(hideAppLoader());
    if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
    else return ex;
  });
};

export const adminAddLocationApi = (id, data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return ptPlusApiBaseUrl.post(`ptms/internal/location/${id}/add`, data, {
    headers: {
      Authorization: token,
      UserType: 'internal'
    },
  }).then((response) => {
    dispatch(hideAppLoader());
    return response.data;
  }).catch((ex) => {
    dispatch(hideAppLoader());
    if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
    else return ex;
  });
};

export const adminUpdateLocationApi = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return ptPlusApiBaseUrl.post(`ptms/internal/location/update_name`, data, {
    headers: {
      Authorization: token,
      UserType: 'internal'
    },
  }).then((response) => {
    dispatch(hideAppLoader());
    return response.data;
  }).catch((ex) => {
    dispatch(hideAppLoader());
    if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
    else return ex;
  });
};

export const adminAddLocationUserApi = (id, data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return ptPlusApiBaseUrl.post(`ptms/internal/location_sub_user/${id}/add`, data, {
    headers: {
      Authorization: token,
      UserType: 'internal'
    },
  }).then((response) => {
    dispatch(hideAppLoader());
    return response.data;
  }).catch((ex) => {
    dispatch(hideAppLoader());
    if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
    else return ex;
  });
};

export const fetchLocationListApi = (id, token) => (dispatch) => {
  dispatch(showAppLoader());
  return ptPlusApiBaseUrl.get(`ptms/internal/loc_and_cust_list/${id}`, {
    headers: {
      Authorization: token,
      UserType: 'internal'
    },
  }).then((response) => {
    dispatch(hideAppLoader());
    return response.data;
  }).catch((ex) => {
    dispatch(hideAppLoader());
    if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
    else return ex;
  });
};
export const fetchPickupLocationListApi = (id, token) => (dispatch) => {
  dispatch(showAppLoader());
  return ptPlusApiBaseUrl.get(`ptms/internal/pickup_location/${id}/list/MAIN`, {
    headers: {
      Authorization: token,
      UserType: 'internal'
    },
  }).then((response) => {
    dispatch(hideAppLoader());
    return response.data;
  }).catch((ex) => {
    dispatch(hideAppLoader());
    if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
    else return ex;
  });
};
export const fetchSpecialLocationListApi = (customerId, token) => (dispatch) => {
  dispatch(showAppLoader());
  return ptPlusApiBaseUrl.get("ptms/internal/locations/" + customerId + "/list/MAIN", {
    headers: {
      Authorization: token,
      UserType: 'internal'
    },
  }).then((response) => {
    dispatch(hideAppLoader());
    return response.data;
  }).catch((ex) => {
    dispatch(hideAppLoader());
    if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
    else return ex;
  });
};
export const fetchAdminLocationListApi = (id, token) => (dispatch) => {
  dispatch(showAppLoader());
  return ptPlusApiBaseUrl.get(`ptms/internal/loc_and_cust_list/active_inactive/${id}`, {
    headers: {
      Authorization: token,
      UserType: 'internal'
    },
  }).then((response) => {
    dispatch(hideAppLoader());
    return response.data;
  }).catch((ex) => {
    dispatch(hideAppLoader());
    if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
    else return ex;
  });
};

export const adminFetchLocationUsersListApi = (id, token) => (dispatch) => {
  dispatch(showAppLoader());
  return ptPlusApiBaseUrl.post(`ptms/internal/location_sub_user/${id}/list`, {}, {
    headers: {
      Authorization: token,
      UserType: 'internal'
    },
  }).then((response) => {
    dispatch(hideAppLoader());
    return response.data;
  }).catch((ex) => {
    dispatch(hideAppLoader());
    return ex;
  });
};

export const checkIsValidEmail = (email, token) => () => {
  return ptPlusApiBaseUrl.get(`ptms/auth/email_exist?email=${email}`, {
    headers: {
      Authorization: token,
      UserType: 'internal'
    },
  }).then((response) => {
    return response.data;
  }).catch((ex) => {
    if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
    else return ex;
  });
};

export const checkIsZipCode = (zip, token) => () => {
  return ptPlusApiBaseUrl.get(`ptms/internal/validate_zip_code/${zip}`, {
    headers: {
      Authorization: token,
      UserType: 'internal'
    },
  }).then((response) => {
    return response.data;
  }).catch((ex) => {
    if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
    else return ex;
  });
};

export const referenceNumberList = (token) => (dispatch) => {
  return ptPlusApiBaseUrl.get("ptms/order/reference_number_list", {
    headers: {
      Authorization: token,
      UserType: 'internal'
    },
  }).then((response) => {
    return response.data;
  }).catch((ex) => {
    if (ex.response) return { error: true, data: ex.response?.data };
    else return ex;
  });
};

export const inviteNewCustomerApi = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return ptPlusApiBaseUrl.post(`ptms/internal/invite_customer`, data, {
    headers: {
      Authorization: token,
      UserType: 'internal'
    },
  }).then((response) => {
    dispatch(hideAppLoader());
    return response.data;
  }).catch((ex) => {
    dispatch(hideAppLoader());
    if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
    else return ex;
  });
};

export const palletDetails = (token) => (dispatch) => {
  return ptPlusApiBaseUrl.get("ptms/order/get_specification", {
    headers: {
      Authorization: token,
      UserType: 'internal'
    },
  }).then((response) => {
    return response.data;
  }).catch((ex) => {
    if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
    else return ex;
  });
};
export const deleteFlatFee = (location_id, flat_fee_id, token) => (dispatch) => {
  return ptPlusApiBaseUrl.get("ptms/user/" + location_id + "/delete_flatfee/" + flat_fee_id, {
    headers: {
      Authorization: token,
      UserType: 'internal',
    },
  }).then((response) => {
    return response.data;
  }).catch((ex) => {
    if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
    else return ex;
  });
};
export const deleteLocation = (location_id, token) => (dispatch) => {
  return ptPlusApiBaseUrl.get("ptms/internal/location/" + location_id + "/delete", {
    headers: {
      Authorization: token,
      UserType: 'internal',
    },
  }).then((response) => {
    return response.data;
  }).catch((ex) => {
    if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
    else return ex;
  });
};
export const deactiveLocation = (location_id, token) => (dispatch) => {
  return ptPlusApiBaseUrl.get("ptms/internal/location/" + location_id + "/deactivate", {
    headers: {
      Authorization: token,
      UserType: 'internal',
    },
  }).then((response) => {
    return response.data;
  }).catch((ex) => {
    if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
    else return ex;
  });
};
export const activeLocation = (location_id, token) => (dispatch) => {
  return ptPlusApiBaseUrl.get("ptms/internal/location/" + location_id + "/activate", {
    headers: {
      Authorization: token,
      UserType: 'internal',
    },
  }).then((response) => {
    return response.data;
  }).catch((ex) => {
    if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
    else return ex;
  });
};
export const reInviteApi = (data, token) => (dispatch) => {
  return ptPlusApiBaseUrl.post("ptms/internal/location_sub_user/resendLink", data, {
    headers: {
      Authorization: token,
      UserType: 'internal',
    },
  }).then((response) => {
    return response.data;
  }).catch((ex) => {
    if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
    else return ex;
  });
};
export const deleteCustomer = (data, token) => (dispatch) => {
  return ptPlusApiBaseUrl.post("ptms/internal/delete_customer", data, {
    headers: {
      Authorization: token,
      UserType: 'internal',
    },
  }).then((response) => {
    return response.data;
  }).catch((ex) => {
    if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
    else return ex;
  });
};
export const updateFlatFee = (data, flat_fee_id, token) => (dispatch) => {
  return ptPlusApiBaseUrl.post("ptms/user/update_flatfee/" + flat_fee_id, data, {
    headers: {
      Authorization: token,
      UserType: 'internal'
    },
  }).then((response) => {
    return response.data;
  }).catch((ex) => {
    if (ex.response) return { error: true, data: ex.response?.data };
    else return ex;
  });
};
export const uploadSpectFile = (formData, token) => (dispatch) => {
  return ptPlusApiBaseUrl
    .post("/s3/upload_file", formData, {
      headers: {
        Authorization: `${token}`,
        UserType: "external",
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((ex) => {
      if (typeof ex == "string") {
        return { ex: { message: ex } };
      }
      return { error: true, data: ex.response?.data };
    });
};
export const uploadSpectFilePTMS = (formData, token) => (dispatch) => {
  return ptPlusApiBaseUrl
    .post("/ptms/s3/upload_file", formData, {
      headers: {
        Authorization: `${token}`,
        UserType: "internal",
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((ex) => {
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

export const createOrder = (date, token) => (dispatch) => {
  dispatch(showAppLoader());
  return ptPlusApiBaseUrl
    .post("/ptms/order/create", date, {
      headers: {
        Authorization: `${token}`,
        UserType: "internal",
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};
export const orderRefNumber = (orderRefNumber, token) => (dispatch) => {
  return ptPlusApiBaseUrl
    .get("/ptms/order/order_ref_number/" + orderRefNumber, {
      headers: {
        Authorization: `${token}`,
        UserType: "internal",
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((ex) => {
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};
export const locationList = (customerId, token) => (dispatch) => {
  return ptPlusApiBaseUrl.get("/internal/locations/" + customerId + "/list/MAIN", {
    headers: {
      Authorization: `${token}`,
      UserType: "internal",
    },
  })
    .then((response) => {
      return response.data;
    })
    .catch((ex) => {
      if (typeof ex == "string") {
        return { ex: { message: ex } };
      }
      return { error: true, data: ex.response?.data };
    });
};


export const allCompanyListApi = (token) => (dispatch) => {
  dispatch(showAppLoader());
  return ptPlusApiBaseUrl.get(`ptms/admin/companyList`, {
    headers: {
      Authorization: token,
      UserType: 'internal'
    },
  }).then((response) => {
    dispatch(hideAppLoader());
    return response.data;
  }).catch((ex) => {
    dispatch(hideAppLoader());
    if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
    else return ex;
  });
};

export const ptPlusOrderReportsApi = (url, data) => (dispatch) => {
  dispatch(showAppLoader());
  const token = localStorage.getItem("token")
  return ptPlusApiBaseUrl.post(url, data, {
    headers: {
      Authorization: token,
      UserType: 'internal'
    },
  })
    .then((response) => {
      dispatch(hideAppLoader());
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;;
    });
};

export const exportPtPlusOrderReportsApi = (url, data) => (dispatch) => {
  // dispatch(showAppLoader());
  const token = localStorage.getItem("token")
  return ptPlusApiBaseUrl.post(url, data, {
    headers: {
      Authorization: token,
      UserType: 'internal'
    },
  })
    .then((response) => {
      // dispatch(hideAppLoader());
      return response.data;
    })
    .catch((ex) => {
      // dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data };
      return ex;
    });
};

export const ptPlusAddParentUserAPI = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return ptPlusApiBaseUrl.post(
    `ptms/parent/register`,
    data,
    {
      headers: {
        Authorization: token,
        UserType: 'internal'
      },
    }
  ).then((response) => {
    dispatch(hideAppLoader());
    return response.data;
  }).catch((ex) => {
    dispatch(hideAppLoader());
    if (ex.response) return {
      error: true,
      data: ex.response?.data,
      statusCode: ex.response?.status
    };
    else return ex;
  });
};

export const ptPlusUpdateParentUserAPI = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return ptPlusApiBaseUrl.post(
    `ptms/parent/update`,
    data,
    {
      headers: {
        Authorization: token,
        UserType: 'internal'
      },
    }
  ).then((response) => {
    dispatch(hideAppLoader());
    return response.data;
  }).catch((ex) => {
    dispatch(hideAppLoader());
    if (ex.response) return {
      error: true,
      data: ex.response?.data,
      statusCode: ex.response?.status
    };
    else return ex;
  });
};

